
import LevelProgress from 'c%/LevelProgress.vue'
import WeeksChart from 'c%/WeeksChart.vue'
import VideoPlayer from 'c%/VideoPlayer.vue'
import moment from 'moment'
import common from '@/libs/common.mixin'
import wxjssdk from '@/libs/wxjssdk.mixin'
import globals from '@/libs/globals.mixin'
import html2canvas from 'html2canvas'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import yuyinpng from '@/assets/review/yuyin.png'
import yuyingif from '@/assets/review/yuyin.gif'
import MyRater from 'c%/MyRater.vue'
import Range from 'c%/range/index.vue'


export default {
directives: {
TransferDom
},
mixins: [common,globals,wxjssdk],
components: {
LevelProgress,
WeeksChart,
Previewer,
VideoPlayer,
MyRater,
Range
},
data() {
return {
weekChartData: [],
scoreChartData: [],
info: {
student: {
photo_url: 'http://s1.xiao360.com/common_img/avatar.jpg',
student_name: '',
honor: {}
},
date: '',
day: '',
time: '',
teacher: {
photo_url: 'http://s1.xiao360.com/common_img/avatar.jpg',
ename: '',
say: '',
common: ''
},
common:[]
},
imgList: [],
videoList: [],
otherFileList: [],
voiceList: [],
qrcode_url: '',
share_text: '',
showPhoto: false,
showPlayer: false,
videoUrl:'',
shareData:'',
hideShareDiv:false,
tpl:null
}
},
mounted() {
this.initData();
},
computed: {
totalWeekNum() {
let total = 0;
this.weekChartData.forEach(item => {
total += item.num;
})
return total
},
activeStar () {
return `<img slot="active" src="/static/img/student/star-sel.png" style="width:16px">`
},
defaultStar () {
return `<img slot="default" src="/static/img/student/star-nor.png" style="width:16px">`
},
showScoreNum(){
if(this.tpl && this.tpl.advance && this.tpl.advance.score_show_num){
return true
}
return false
}

},
filters: {
toVoiceTime(val) {
let total = Math.round(val);
let m = Math.floor(total / 60);
let s = total % 60;
return `${m}'${s}''`
}
},
methods: {
nlbr(val){
return val.replace(/[\n\r]+/g,'<br>')
},
openPlayer() {
this.showPlayer = true;
},
dlFile(file) {
this.$vux.confirm.show({
content: '下载文件：' + file.file.file_name,
onConfirm () {
window.open(file.file_url);
}
})
},
playVoice(index) {
let audioElement = this.$refs['voice'][index];
let voiceImgElement = this.$refs['voiceImg'][index];
audioElement.addEventListener('ended', function() {
voiceImgElement.src = yuyinpng;
}, false)
audioElement.play();
voiceImgElement.src = yuyingif;
},
closeSharePhoto() {
this.showPhoto = false;
},
share() {
this.showPhoto = true;

if(this.shareData != ''){
this.hideShareDiv = true
return
}
setTimeout(()=>{
html2canvas(this.$refs['share-page'], {
useCORS: true

}).then(canvas => {
this.shareData = canvas.toDataURL()
this.hideShareDiv = true








});
},1000)
},
showImg(img) {

this.previewImage(img,this.imgList)
},
initData() {
this.$http.get('share/my_review_detail?rs_id='+this.$route.params.id)
.then(res => {
let data = res.body.data;

if(data.student.photo_url) {
this.info.student.photo_url = data.student.photo_url;
}
this.info.student.student_name = data.student.student_name;
document.title = this.info.student.student_name + '的学习报告'
this.setFormatDate(data.int_day);
this.setFormatTime(data.int_start_hour, data.int_end_hour);


let tplSetting = data.review.review_tpl_setting,
tpl = null;
if(tplSetting) {
tpl = data.review.review_tpl_setting.setting;
}
else {
tpl = data.review_styles[1];
}
this.tpl = tpl

try{
let content = JSON.parse(data.review.content)
tpl.common_fields.forEach(f=>{
if(f.enable && f.student_view && content[f.field] != ''){
this.info.common.push({
label:f.label,
content:this.nlbr(content[f.field])
})
}
})
}catch(e){
console.log(e)
}
let honorTpl = null
if(data.detail.honor.index > -1){
honorTpl = tpl.student_fields.honor[data.detail.honor.index];
}
let scoreTpl = tpl.student_fields.score;
let weakTpl = tpl.student_fields.weak;
if(honorTpl){
this.info.student.honor.image = honorTpl.image;
this.info.student.honor.label = honorTpl.label;
}else{
this.info.student.honor.image = ''
this.info.student.honor.label = ''
}
this.info.student.honor.content = data.detail.honor.content;


let aindex = 0
tpl.student_fields.score.forEach(sc=>{
aindex++
if(sc.enable){
let max = 5 , step = 1 , alias_index = aindex
if(sc.max){
max = sc.max
}
if(sc.step){
step = sc.step
}
if(step > 1){
alias_index = data.detail[sc.field]/step
}else{
alias_index = data.detail[sc.field]
}
this.scoreChartData.push({
label:sc.label,
num:data.detail[sc.field],
alias:sc.alias[alias_index],
max:max,
step:step
})
}
})



/*
for (let index = 0; index < 5; index++) {
if(('score'+index) in data.detail) {
this.scoreChartData.push({
label: scoreTpl[index].label,
num: data.detail['score'+index],
alias: scoreTpl[index].alias[data.detail['score'+index]]
})
}
}*/


for (let index = 0; index < 5; index++) {
if(('weak'+index) in data.detail) {
this.weekChartData.push({
label: weakTpl[index].label,
num: data.detail['weak'+index].value,
desc: data.detail['weak'+index].desc
})
}
}


let fileList = data.review.review_file,
imgList = [],
videoList = [],
voiceList = [],
otherFileList = []
fileList.forEach(item => {
if(item.media_type == 'image') {




imgList.push(item.file_url)
}
else if(item.media_type == 'video'){
videoList.push(item)
}
else if(item.media_type == 'voice') {
voiceList.push(item)
}
else {
otherFileList.push(item)
}
})
this.imgList = imgList;
this.videoList = videoList;
this.voiceList = voiceList;
this.otherFileList = otherFileList;



if(data.employee.photo_url) {
this.info.teacher.photo_url = data.employee.photo_url;
}
this.info.teacher.say = data.detail.detail;
let commonTpl = tpl.common_fields;
this.info.teacher.ename = data.employee.ename;
let content = JSON.parse(data.review.content),
common = '';
for(let prop in content) {
let label = '';
for (let index = 0; index < commonTpl.length; index++) {
const item = commonTpl[index];
if(item.field == prop) {
label = item.label;
}
}
common += label + '：' + content[prop]+'<br>';
}
this.info.teacher.common = common;


let shareTpl = tpl.student_fields.share_ad;
this.share_text = shareTpl.text;
if(shareTpl.qr) {
this.qrcode_url = shareTpl.qr;
}
else {
this.qrcode_url = data.qrcode_url[0].qrcode_url;
}
},res => {
this.$Message.error(res.body.message)
})
},
setFormatDate(int_day) {
let instance = moment(int_day+'','YYYYMMDD');
this.info.date = instance.format('MM月DD日');
let day_num = instance.format('d');
let day_map = ['日','一','二','三','四','五','六'];
this.info.day = '周' + day_map[day_num];
},
setFormatTime(start, end) {
this.info.time = this.$filter('int_hour')(start) + '-' + this.$filter('int_hour')(end);
},
playVideo(url){
this.videoUrl = url
this.showPlayer = true
}
}
}



// WEBPACK FOOTER //
// ./src/views/public/scomment.vue